/**
 * Store quản lý cấu hình ứng dụng
 * @description Quản lý các cấu hình giao diện và bố cục của ứng dụng
 */
export const useConfigStore = defineStore('configStore', {
  /**
   * Khởi tạo state của store
   * @returns {object} State ban đầu của config store
   */
  state: () => ({
    /** Chủ đề giao diện: 'light' hoặc 'dark' */
    theme: 'light',

    /** Kiểu bố cục điều hướng: 'vertical' hoặc 'horizontal' */
    appContentLayoutNav: 'vertical',
  }),

  actions: {
    /**
     * Thiết lập chủ đề giao diện
     * @description Cập nhật chủ đề giao diện của ứng dụng
     * @param {string} theme - Chủ đề giao diện ('light' hoặc 'dark')
     */
    setTheme(theme: string) {
      this.theme = theme
    },

    /**
     * Thiết lập kiểu bố cục điều hướng
     * @description Cập nhật kiểu bố cục điều hướng của ứng dụng
     * @param {string} layout - Kiểu bố cục ('vertical' hoặc 'horizontal')
     */
    setAppContentLayoutNav(layout: string) {
      this.appContentLayoutNav = layout
    },
  },

  getters: {
    /**
     * Lấy chủ đề giao diện hiện tại
     * @returns {string} Chủ đề giao diện hiện tại
     */
    getTheme(): string {
      return this.theme
    },
  },

  /**
   * Cấu hình lưu trữ dữ liệu
   * @description Lưu trữ state vào localStorage để giữ cấu hình giữa các phiên làm việc
   */
  persist: {
    storage: piniaPluginPersistedstate.localStorage(),
    key: 'configStore',
  },
})

/**
 * Cho phép cập nhật Hot Module Replacement cho store
 */
acceptHMRUpdate(useConfigStore, import.meta.hot)
